/** 주문명 — PortOne·검증 로직과 동일 문자열 유지 */
export const SLEEP_CARE_ORDER_NAME = 'SOMNIA Sleep Care Program';

/** PortOne 콘솔의 스토어·KG이니시스 채널 (기존 somnia 체크아웃과 동일 기본값) */
export const PORTONE_STORE_ID =
  process.env.REACT_APP_PORTONE_STORE_ID || 'store-8c607d6d-88c0-4a95-b944-98696ee51168';
export const PORTONE_CHANNEL_KEY =
  process.env.REACT_APP_PORTONE_CHANNEL_KEY || 'channel-key-16b5b859-42da-441e-bc63-64fc7b477f7b';
